import { useNavigate } from "react-router-dom";
import "./inventoryprofileheader.scss";
import { Button } from "react-bootstrap";

const InventoryProfileHeader = ({ status, itemName, itemBarcode, isAddButtonShow }: any) => {
  const navigate = useNavigate();

  return (
    <div className="inventory-profile-header-wrapper">
      <div className="inventory-title-status-box">
        <div className="inventory-name-barcode">
          <h2>{itemName}</h2>
          {itemBarcode && <span className="item-barcode">{itemBarcode}</span>}
        </div>
        <div
          className={`status-box
          ${status ? "active" : "inactive"}`}
        >
          <span className="status-circle"></span>
          <span className="status-text">{status ? "Active" : "Inactive"}</span>
        </div>
      </div>
      {isAddButtonShow && (
        <Button variant="primary" onClick={() => navigate("/create-inventory")}>
          <i className="bi bi-plus"></i> Add Item
        </Button>
      )}
    </div>
  );
};

export default InventoryProfileHeader;
